import { gql, useQuery } from '@apollo/client';

export const GET_EMPLOYEE_BY_ID = gql`
  query ($payload: GetEmployeeByIdInput!) {
    getEmployeeById(payload: $payload) {
      _id
      createdAt
      createdBy
      firstName
      lastName
      email
      phoneNumber
      avatarUrl
      nickname
      ganttId
      gantt {
        name
      }
      workingDays {
        startFromString
        startFrom
        breakTime
        monday {
          from
          to
        }
        tuesday {
          from
          to
        }
        wednesday {
          from
          to
        }
        thursday {
          from
          to
        }
        friday {
          from
          to
        }
        saturday {
          from
          to
        }
        sunday {
          from
          to
        }
      }
    }
  }
`;

export const useGetEmployeeById = ({ _id, companyId }: { _id: string; companyId?: string }) => {
  const { data, loading } = useQuery(GET_EMPLOYEE_BY_ID, {
    variables: {
      payload: {
        _id,
        companyId,
      },
    },
    fetchPolicy: 'network-only',
    skip: !companyId,
  });

  const employee = data?.getEmployeeById || {};

  return { employee, loading };
};
